import { Injectable } from '@angular/core';
import { HttpClientService } from '@app/services/util-services/root-services/http-client.service';
import { Observable } from 'rxjs';
import {
  ApiResponseBody,
  NewRequestBodyModel,
} from '@app/models/client/new-request-body.model';

@Injectable({
  providedIn: 'root',
})
export class SearchFormService {
  constructor(private httpClientService: HttpClientService) {}

  submitFormData(
    apiUrl: string,
    query: NewRequestBodyModel
  ): Observable<ApiResponseBody> {
    return this.httpClientService.post(apiUrl, query, {});
  }
}
